var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFfRrCommunity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_9089)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3,
    r: 1.5,
    stroke: "#858D9D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 6,
    rx: 2.25,
    ry: 1.5,
    stroke: "#858D9D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12,
    r: 1.5,
    stroke: "#858D9D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5M9 16.5C4.85786 16.5 1.5 13.1421 1.5 9",
    stroke: "#858D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 15,
    rx: 2.25,
    ry: 1.5,
    stroke: "#858D9D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_9089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfRrCommunity);
export default __webpack_public_path__ + "static/media/ff-rr-community.d87c515b631c968181e10c272a94ed88.svg";
export { ForwardRef as ReactComponent };